const styles = `:host {
  --goto-icon-color: var(--goto-interactive-01);
  color: var(--goto-text-01);
  padding-right: var(--goto-spacing-05);
  border-radius: 0;
  margin: 0;
}
:host [part=start] {
  width: 36px;
  display: inline-flex;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 18px;
}

:host(:not([disabled]):hover) {
  background: var(--goto-interactive-01);
  color: var(--goto-text-04);
}

:host([disabled]),
:host([disabled]:hover) {
  color: var(--goto-disabled-04);
}

:host([aria-selected=true]) {
  --goto-icon-color: var(--goto-text-04);
  background: var(--goto-interactive-01);
  color: var(--goto-text-04);
}`; export default styles;